import { connect } from 'react-redux';
import VehicleDescription from 'vdp-used/components/VehicleDescription/VehicleDescription.jsx';

function mapStateToProps(state) {
    return {
        vehicle: state.vehicleV25,
    };
}

export default connect(mapStateToProps)(VehicleDescription);
